// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellAndComment16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-and-comment': IconBellAndComment;
    }
}

/**
 * The icon component for the 'bellAndComment' icon
 */
export class IconBellAndComment extends IconSvg {
    public constructor() {
        super(bellAndComment16X16);
    }
}

registerIconSvg('icon-bell-and-comment', IconBellAndComment);
export const iconBellAndCommentTag = 'nimble-icon-bell-and-comment';
